import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "14",
  height: "14",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  d: "M11.708 2.292A6.631 6.631 0 0 0 7 .334 6.658 6.658 0 0 0 .342 7.001 6.658 6.658 0 0 0 7 13.667c3.108 0 5.7-2.125 6.442-5h-1.734A4.992 4.992 0 0 1 7 12.001c-2.758 0-5-2.242-5-5 0-2.759 2.242-5 5-5a4.93 4.93 0 0 1 3.517 1.483L7.833 6.167h5.834V.334l-1.959 1.958Z",
  fill: "#F9F7FA"
}, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3))
}
export default { render: render }